import React from "react";
import * as fetchingState from '../../../constants/fetchingState';
import { Alert, Glyphicon } from "react-bootstrap";
const renderRow = (smsCountersForRegistration, isReadOnly, onEdit) => {
    return (
        <tr key={smsCountersForRegistration.Id}>
            <td>{smsCountersForRegistration.Phone}</td>
            <td>{smsCountersForRegistration.SmsCount}</td>
            <td>
                <Glyphicon 
                    glyph='refresh' 
                    className={`edit-glyph${isReadOnly ? '.disabled' : ''}`} 
                    onClick={isReadOnly ? undefined : () => onEdit(smsCountersForRegistration.Id)} 
                    title='Обнулить' />
            </td>
        </tr>
    );
};
export const Table = ({ countersForRegistrations, fetching, isReadOnly, onEdit }) => (
    <div>
        {fetching === fetchingState.FETCHING && <Alert bsStyle='info'>Загрузка...</Alert>}
        {fetching === fetchingState.FAILED && <Alert bsStyle='danger'>Ошибка загрузки</Alert>}
        {fetching === fetchingState.FETCHED &&
            <table className='table table-hover'>
                <thead>
                    <tr>
                        <td>Телефон</td>
                        <td>Количество попыток</td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    {countersForRegistrations.map(d => renderRow(d, isReadOnly,onEdit))}
                </tbody>
            </table>}
    </div>
);


// WEBPACK FOOTER //
// ./src/components/settings/smslimit/Table.jsx